module.exports = __webpack_public_path__ + "img/shadow.be45d7b.png";